import { Calendar, Mail, Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/shared/components/ui/button';
import { useStartCalendarConnection, type CalendarProviderSlug } from '@/features/calendar/public';

/**
 * OAuth connect CTAs. No brand assets exist in the project — generic lucide
 * icons + provider name as text (per spec 3.9).
 */
export function ConnectProviderButtons() {
  const { t } = useTranslation('calendar');
  const startConnection = useStartCalendarConnection();

  function handleConnect(provider: CalendarProviderSlug) {
    startConnection.mutate(provider, {
      onError: () => {
        // global handler shows error toast
      },
    });
  }

  const pending = startConnection.isPending;

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="settings-integrations-connect">
      <Button
        variant="outline"
        size="sm"
        disabled={pending}
        onClick={() => handleConnect('google')}
        data-testid="settings-integrations-connect-google"
      >
        {pending && startConnection.variables === 'google' ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : (
          <Calendar className="h-4 w-4" />
        )}
        {t('integrations.connect.google')}
      </Button>
      <Button
        variant="outline"
        size="sm"
        disabled={pending}
        onClick={() => handleConnect('microsoft')}
        data-testid="settings-integrations-connect-microsoft"
      >
        {pending && startConnection.variables === 'microsoft' ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : (
          <Mail className="h-4 w-4" />
        )}
        {t('integrations.connect.microsoft')}
      </Button>
    </div>
  );
}
